<template>
  <v-dialog v-model="dialog" :max-width="600" persistent @keydown.esc="cancel()">
    <v-card>
      <v-card-title class="primary white--text">
        {{ user.id ? $t('henkilo.edit_henkilo') : $t('henkilo.new_henkilo') }}
      </v-card-title>
      <v-card-text class="pt-5">
        <v-text-field v-model="user.email" :disabled="editUser" :label="$t('henkilo.email')"/>
        <v-text-field v-model="user.firstname" :disabled="saving" :label="$t('henkilo.first_name')"/>
        <v-text-field v-model="user.lastname" :disabled="saving" :label="$t('henkilo.last_name')"/>
      </v-card-text>
      <v-divider/>
      <v-card-text class="pt-5">

        <v-autocomplete

            :key="vastuualueSelection"
            :disabled="saving"
            :item-text="(item) => item.nimi"
            :items="filteredVastuualueet"
            :label="$tc('vastuualue.add_vastuualue',1)"
            item-value="id"
            return-object
            validate-on-blur
            @change="addVastuualue"
        />
        <v-list>
          <template v-for="(vastuualueLink, i) in userVastuualueLinkit">
            <v-list-item :key="i" :class="[vastuualueLink.deleted && 'error']">
              <v-list-item-content>
                <v-row class="align-center">
                  <v-col class="align-center" cols="12" md="6">
                    <span v-if="vastuualueLink.vastuualue">{{ vastuualueLink.vastuualue.nimi }}</span>
                  </v-col>
                  <v-col class="align-center" cols="12" md="4">
                    <v-autocomplete v-model="vastuualueLink.rooli" :item-text="(item) => item.label"
                                    :item-value="(item) => item.value"
                                    :items="roles" dense hide-details>

                    </v-autocomplete>
                  </v-col>
                  <v-col class="text-right" cols="12" md="2">
                    <v-btn icon @click="deleteVastuualueLink(vastuualueLink,i)">
                      <v-icon>mdi mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

              </v-list-item-content>
            </v-list-item>
          </template>

        </v-list>
      </v-card-text>
      <v-divider/>
      <v-card-text class="pt-5">

        <v-autocomplete

            :key="oikeusSelection"
            :disabled="saving"
            :item-text="(item) => `${item.firstname} ${item.lastname}`"
            :items="filteredUsers"
            :label="$tc('henkilo.add_oikeus_user',1)"
            item-value="id"
            return-object
            validate-on-blur
            @change="addOikeus"
        />
        <v-list>
          <template v-for="(oikeus, i) in userKayttajanOikeusToiseen">
            <v-list-item :key="i" :class="[oikeus.deleted && 'error']">
              <v-list-item-content>
                <v-row class="align-center">
                  <v-col class="align-center" cols="10" md="10">
                    <span v-if="oikeus.oikeusUser">{{ oikeus.oikeusUser.firstname }} {{
                        oikeus.oikeusUser.lastname
                      }} </span>
                  </v-col>
                  <v-col class="text-right" cols="2" md="2">
                    <v-btn icon @click="deleteOikeus(oikeus,i)">
                      <v-icon>mdi mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

              </v-list-item-content>
            </v-list-item>
          </template>

        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
        <v-btn v-if="user.id"
               :block="$vuetify.breakpoint.xsOnly"
               :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
               :large="$vuetify.breakpoint.xsOnly"
               :loading="deleting"
               :text="$vuetify.breakpoint.smAndUp"
               color="error"
               @click="deleteUser()"
        >
          {{ $t('delete') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
            :large="$vuetify.breakpoint.xsOnly"
            :text="$vuetify.breakpoint.smAndUp"
            @click="cancel()"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
            :large="$vuetify.breakpoint.xsOnly"
            :loading="saving"
            color="primary"
            @click="save()"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/apicollection";

export default {
  name: 'HenkiloDialog',

  props: {
    users: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      dialog: false,
      user: {
        firstname: '',
        lastname: '',
        email: '',
        vastuualueLinkit: [],
        kayttajanOikeusToiseen: []
      },
      saving: false,
      editUser: false,
      deleting: false,
      vastuualueet: [],
      vastuualue: null,
      vastuualueSelection: 'selection_key',
      oikeusSelection: 'oikeus_selection_key',
      roles: [
        {value: 'role_member', label: this.$t('henkilo.roles.role_member')},
        {value: 'role_guest', label: this.$t('henkilo.roles.role_guest')},
      ]
    };
  },
  computed: {
    filteredVastuualueet() {
      const selectedVastuualueet = this.user?.vastuualueLinkit?.map(link => link.vastuualueId) || []
      return this.vastuualueet.filter(v => !selectedVastuualueet.includes(v.id))
    },
    userVastuualueLinkit() {
      return this.user?.vastuualueLinkit?.map(v => {
        if (v.vastuualue == null && v.vastuualueId) {
          v.vastuualue = this.vastuualueet.find(vv => vv.id === v.vastuualueId);
        }
        return v;
      }) || [];
    },
    userKayttajanOikeusToiseen() {
      return this.user?.kayttajanOikeusToiseen?.map(v => {
        return v;
      }) || [];
    },
    filteredUsers() {
      return this.users.filter(u => u.id !== this.user.id && !this.userKayttajanOikeusToiseen.find(v => v.oikeusUserId === u.id));

    }
  },
  methods: {
    open(user) {
      if (user) {
        const userCopy = {...user};
        this.editUser = true;
        userCopy?.vastuualueLinkit?.map(v => {
          v.deleted = false;
          return v;
        })
        this.user = userCopy
      } else {
        this.editUser = false;
      }
      this.dialog = true;
    },
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueet();
      this.vastuualueet = vastuualueet;
    },
    addVastuualue(vastuualue) {
      if (this.user.vastuualueLinkit == null) {
        this.user.vastuualueLinkit = [];
      }
      this.user.vastuualueLinkit.push({
        vastuualue: vastuualue,
        vastuualueId: vastuualue.id,
        rooli: 'role_member'
      })
      this.vastuualueSelection = "selection_key_" + this.$uuid();
    },
    addOikeus(user) {
      if (this.user.kayttajanOikeusToiseen == null) {
        this.user.kayttajanOikeusToiseen = [];
      }
      this.user.kayttajanOikeusToiseen.push({
        oikeusUserId: user.id,
        oikeusUser: user,
      })
      this.oikeusSelection = "oikeus_selection_key_" + this.$uuid();
    },
    deleteVastuualueLink(vastuualueLink, i) {
      vastuualueLink.deleted = !vastuualueLink.deleted
      this.$set(this.user.vastuualueLinkit, i, vastuualueLink)
    },
    deleteOikeus(oikeus, i) {
      oikeus.deleted = !oikeus.deleted
      this.$set(this.user.kayttajanOikeusToiseen, i, oikeus)
    },
    async save() {
      this.saving = true;
      try {
        if (this.user.id) {
          await api.updateUser(this.user.id, {...this.user});
        } else {
          await api.addUser({...this.user});
        }
        this.$showSuccessNotification(this.$t('henkilo.saved'), false);
        this.user.vastuualueLinkit = this.user.vastuualueLinkit?.filter(v => v.deleted !== true) || [];
        if (this.user.id === this.$user.id) {
          window.location.reload(); // Päivitetään sivu, jotta $user muuttuu
        }
        this.cancel();
      } catch (e) {

        if ("Email already in user".indexOf(e)) {
          this.$showErrorNotification(this.$t('henkilo.api.email_already_in_use'), false);
        } else {
          this.$showErrorNotification(this.$t('errors.error_saving_henkilo'))
        }
      }
      this.$emit('saved')
      this.saving = false;
    },
    async deleteUser() {
      this.deleting = true;
      if (this.user.id) {
        try {
          await api.deleteUser(this.user.id);
          this.$showSuccessNotification(this.$t('henkilo.deleted'), false);
          this.$emit('saved')
          this.cancel();
        } catch (e) {
          if (e?.errorCode) {
            this.$showErrorNotification(this.$t(`errors.error_deleting_henkilo_${e.errorCode.toLowerCase()}`))
          } else {
            this.$showErrorNotification(this.$t('errors.error_deleting_henkilo'))
          }
        }
      }
      this.deleting = false;

    },
    cancel() {
      this.dialog = false;
      this.user.firstname = '';
      this.user.lastname = '';
      this.user.email = '';
      this.user.id = '';
      this.user.vastuualueLinkit = [];
      this.user.kayttajanOikeusToiseen = [];
    },
  },
  mounted() {
    this.getVastuualueet();
  }
};
</script>

<style lang="scss" scoped>
.deleted {
  //background: var(--)
}
</style>
